const PAGINATION = {
  PAGE_DEFAULT: 1,
  PAGE_SIZE_DEFAULT: 10,
};

const ALL = 'ALL';

export { PAGINATION, ALL };
